import { render, staticRenderFns } from "./SrContactCreate.vue?vue&type=template&id=039ad22b&"
import script from "./SrContactCreate.vue?vue&type=script&lang=js&"
export * from "./SrContactCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports